import { useNavigate } from "react-router-dom";

export const NavTabs = ({ prefix = "tab", content, guides, testimonials, onAbout, onContact }) => {
  const navigate = useNavigate();
  const tabBtnClass = "rounded-full border border-border px-5 py-2 text-sm hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors duration-300";
  return (
    <>
      {content?.nav_programs_visible !== false && (
        <button data-testid={`${prefix}-programs`} onClick={() => document.getElementById("programs")?.scrollIntoView({ behavior: "smooth", block: "start" })} className={tabBtnClass}>{content?.nav_programs_label || "Programs"}</button>
      )}
      {content?.guides_visible && guides.length > 0 && (
        <button data-testid={`${prefix}-guides`} onClick={() => navigate("/guides")} className={tabBtnClass}>{content?.nav_guides_label || "Guides"}</button>
      )}
      {content?.testimonials_visible && testimonials.length > 0 && (
        <button data-testid={`${prefix}-testimonials`} onClick={() => document.getElementById("testimonials")?.scrollIntoView({ behavior: "smooth" })} className={tabBtnClass}>{content?.nav_testimonials_label || "Testimonials"}</button>
      )}
      {content?.nav_about_visible !== false && (
        <button data-testid={`${prefix}-about`} onClick={onAbout} className={tabBtnClass}>{content?.nav_about_label || "About"}</button>
      )}
      {content?.nav_contact_visible !== false && (
        <button data-testid={`${prefix}-contact`} onClick={onContact} className="rounded-full bg-primary text-primary-foreground px-5 py-2 text-sm hover:-translate-y-0.5 transition-transform duration-300">{content?.nav_contact_label || "Contact"}</button>
      )}
    </>
  );
};
